export const verifyToken = async (token, gameType = "winGo") => {
  try {
    const response = await fetch("https://wingo-backend.desiapi.com/api/user/verifyToken", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token, gameType }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error verifying token:", error);
    return { status: false, message: "Error verifying token" };
  }
};

export const connectSocket = (token, onMessage, onError, onOpen, onClose) => {
  const ws = new WebSocket("wss://wingo-backend.desiapi.com/ws/", token);
  // The tenant gateway waits for SUBSCRIBE; it does not send a pre-subscription greeting.
  const openingTimeout = setTimeout(() => {
    if (ws.readyState === WebSocket.CONNECTING) {
      if (onError) onError(new Error('Game connection timed out.'));
      ws.close();
    }
  }, 12000);
  ws.onopen = () => {
    clearTimeout(openingTimeout);
    if (onOpen) onOpen();
  };

  ws.onmessage = (event) => {
    try {
      const response = JSON.parse(event.data);

      if (response.message === "Connection established and authenticated!") {
        return;
      }

      if (onMessage) onMessage(response);
    } catch (error) {
      console.error("Invalid WebSocket message:", error);
      if (onError) onError(error);
    }
  };

  
  ws.onerror = (error) => {
    clearTimeout(openingTimeout);
    console.error("WebSocket error:", error);
    if (onError) onError(error);
  };

  
  ws.onclose = (event) => {
    clearTimeout(openingTimeout);
    if (onClose) onClose(event);
  };

  return ws;
};

export const subscribeToChannel = (socket, gameType = "winGo",issue) => {
  if (!socket || socket.readyState !== WebSocket.OPEN) return false;
  const subscribeMessage = {
    type: "SUBSCRIBE",
    gameType: gameType,
    issue: issue,
  };
  socket.send(JSON.stringify(subscribeMessage));
  return true;
};

export const unsubscribeFromChannel = (socket, gameType = "winGo") => {
  if (!socket || socket.readyState !== WebSocket.OPEN) return false;
  const unsubscribeMessage = {
    type: "UNSUBSCRIBE",
    gameType: gameType,
  };
  socket.send(JSON.stringify(unsubscribeMessage));
  return true;
};

export const placeBet = (socket, { userId, sessionId, betAmount, betType, betValue, betSession, gameType = "winGo" }) => {
  if (!socket || socket.readyState !== WebSocket.OPEN) return false;

  const betMessage = {
    type: "PLACE_BET",
    gameType,
    userId,
    sessionId,
    betAmount,
    betType,
    betValue,
    betSession,
  };

  try { socket.send(JSON.stringify(betMessage)); return true; }
  catch { return false; }
};


export const changeIssue = (socket, { gameType = "winGo", issue = "issue1" }) => {
  if (!socket) return;

  const changeIssueMessage = {
    type: "CHANGE_ISSUE",
    gameType,
    issue: issue,
  };

  socket.send(JSON.stringify(changeIssueMessage)); 
};
export const refreshBalance = (socket, { gameType = "winGo", userId}) => {
  if (!socket) return;

  const changeIssueMessage = {
    type: "REFRESH_BALANCE",
    gameType,
    userId: userId,
  };

  socket.send(JSON.stringify(changeIssueMessage)); 
};


export const handleWebSocketMessage = (message) => {
  switch (message.type) {
    case "USER_BALANCE":
      // console.log(`User balance: ${message.userBalance}`);
      break;

    case "SESSION_HISTORY":
      // console.log(`Session history for ${message.issue}:`, message.sessions);
      break;

    case "NOTIFICATION":
      // console.log(`Notification: ${message.notification.text}`);
      break;

    case "GAME_STARTED":
      // console.log(`Game started for issue: ${message.issue}`);
      break;

    case "GAME_ENDED":
      // console.log(`Game ended for issue: ${message.issue}. Winning number: ${message.winningNumber}`);
      break;

    case "BET_RESULT":
      // console.log(`Bet result for issue: ${message.issue}`);
      // console.log(`Bet status: ${message.result.status}, Win amount: ${message.result.winAmount}`);
      break;

    case "COUNT_DOWN":
      // console.log(`Countdown for issue: ${message.issue}. Time left: ${message.remainingTime}`);
      break;

    case "BETTING_CLOSED":
      // console.log(`Betting closed for issue: ${message.issue}. Session ID: ${message.sessionId}`);
      break;

    case "ERROR":
      // console.log(`Error: ${message.message}`);
      break;

    default:
      // console.log(`Received unknown message type: ${message.type}`);
  }
};


export const fetchHowToPlay = async (issue, token) => {
  try {
    const response = await fetch(`https://wingo-backend.desiapi.com/api/winGo/getHowToPlay/${issue}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${token}`, 
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching how to play:', error);
    return { status: false, message: 'Error fetching how to play' };
  }
};
export const fetchIssueSession = async (issue,page, token, signal) => {
  try {
    const response = await fetch(`https://wingo-backend.desiapi.com/api/winGo/getIssueSessions/${issue}?page=${page}`, {
      method: 'GET',
      signal,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${token}`, 
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching issue sessions:', error);
    return { status: false, message: 'Error fetching issue sessions' };
  }
};

export const fetchUserBets = async (userId, page = 1, token,issue="issue1", signal) => {
  try {
    const response = await fetch(`https://wingo-backend.desiapi.com/api/winGo/getUserBets/${userId}/${issue}?page=${page}`, {
      method: 'GET',
      signal,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${token}`, 
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching user bets:", error);
    return { status: false, message: "Error fetching user bets" };
  }
};


